import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogMolds } from "../../../repositories/CatalogMoldRepository";
import { TableMold } from "../components/TableMold";
import { useCatalogMoldContext } from "../context/CatalogMoldContext";
type Props = {};

export const CatalogMoldPage = (props: Props) => {
  const { actions } = useCatalogMoldContext();
  const { moldId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogMoldsFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogMolds();
    if (resp.ok) {
      const molds = get(resp, "data.tables[0].rows", []);
      actions.setMolds(molds);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogMoldsFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Molds"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableMold
              moldId={moldId}
              isLoading={isLoading}
              getCatalogMoldsFromAPI={getCatalogMoldsFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
